/**
 * @param {string} name
 * @returns {string}
 */
 export function getQueryString(name) {
  let reg = `(^|&)${name}=([^&]*)(&|$)`
  let r = window.location.search.substr(1).match(reg); 
  if (r != null) return unescape(r[2]); return null; 
}

// 日期格式化
export function parseTime(time, pattern) {
	if (arguments.length === 0 || !time) {
		return null
	}
	const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
	let date
	if (typeof time === 'object') {
		date = time
	} else {
		if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
			time = parseInt(time)
		} else if (typeof time === 'string') {
			time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm),'');
		}
		if ((typeof time === 'number') && (time.toString().length === 10)) {
			time = time * 1000
		}
		date = new Date(time)
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay()
	}
	const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
		let value = formatObj[key]
		// Note: getDay() returns 0 on Sunday
		if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
		if (result.length > 0 && value < 10) {
			value = '0' + value
		}
		return value || 0
	})
	return time_str
}

/**
 * 判断是否是微信环境
 */
export function isWeixin() {
	const ua = navigator.userAgent.toLowerCase();
	let isWeixinBrowser = ua.indexOf('micromessenger') != -1;
	return isWeixinBrowser;
}

export function isMobileEnv () {
  let userAgentInfo = navigator.userAgent;
  let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
  let getArr = Agents.filter(i => userAgentInfo.includes(i));
  return getArr.length ? true : false;
}

// 判断是否手机
export function isMobile (callback) {
	if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
			callback(true); // 手机端
	} else {
			callback(false); // alert('PC端')
	}
}

// 首字母大小
export function titleCase(str) {
  return str.replace(/( |^)[a-z]/g, L => L.toUpperCase())
}

// 下划转驼峰
export function camelCase(str) {
  return str.replace(/_[a-z]/g, str1 => str1.substr(-1).toUpperCase())
}

// 正数且保留2位小数
export function toRegNum(num) {
  num = String(num);
  let str = num;
  let len1 = str.substr(0, 1);
  let len2 = str.substr(1, 1);
  //如果第一位是0，第二位不是点，就用数字把点替换掉
  if (str.length > 1 && len1 == 0 && len2 != ".") {
    str = str.substr(1, 1)
  }
  //第一位不能是.
  if (len1 == ".") {
    str = ""
  }
  //限制只能输入一个小数点
  if (str.indexOf(".") != -1) {
    let str_ = str.substr(str.indexOf(".") + 1)
    if (str_.indexOf(".") != -1) {
      str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1)
    }
  }
  //正则替换
  str = str.replace(/[^\d^\.]+/g, '') // 保留数字和小数点
  // str = str.replace(/\.\d\d\d$/, '') // 小数点后只能输两位
  if(str.indexOf('.') > 0) {
    str = str.substr(0, str.indexOf('.')+3);
  }
  return str;
}

// 通用的文本框去除特殊字符(支持：（）_-) 同时支持全角、半角
export function trimSpecial(string) {
  if(string != "") {
    const pattern = /[`~!@#$%^\&*+=|{}':;',\\\[\]\.<>\/?~！@#￥……&*|{}【】'；：""'。，、？\s]/g;
    string = string.replace(pattern, "");
  }
  return string
}

// 说明类的文本框去除特殊字符(支持：（）_-，。？、……！【】%：/+=~——；) 同时支持全角、半角
export function infoTrimSpecial(string) {
  if(string != "") {
    const pattern = /`!@#$^\&*|{}':;'\\\[\]\.<>\?~@#￥&*|{}'：""'\s/g;
    string = string.replace(pattern, "");
  }
  return string
}

//  正则匹配-只能输入数字
export function checkNumber(num) {
  if(num !== "") {
    num = num.replace(/[^\d]/g, '');
  }
  return num;
}

//  正则匹配银行卡-只能输入数字和字母
export function checkNumAndLetters(num) {
  if(num !== "") {
    num = num.replace(/[\W]/g, '');
  }
  return num;
}

//  正则匹配只能输入字母
export function checkLetters(str) {
  if(str !== "") {
    str = str.replace(/[^\a-\z\A-\Z]/g, '');
  }
  return str;
}

//  手机号正则匹配
export function checkPhone(telephone) {
  if(telephone != "") {
    const reg = new RegExp("^1[23456789][0-9]{9}$", 'i');
    if(!reg.test(telephone)) {
      return false;
    } else {
      return true;
    }
  }
}

// 正则匹配座机和手机号
export function checkTel(telephone) {
  if(telephone !== '') {
    let isPhone = /^([0-9]{3,4}-)?[0-9]{7,8}$/;
    let isMob = /^((\+?86)|(\(\+86\)))?(13[012356789][0-9]{8}|15[012356789][0-9]{8}|18[02356789][0-9]{8}|147[0-9]{8}|1349[0-9]{7})$/;
    if(typeof(telephone) === String) {
      telephone = telephone.trim();
    }
    if(isMob.test(telephone) || isPhone.test(telephone)){
      return true;
    } else {
      return false;
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/index.js